"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var SubtitleVariant_less_1 = __importDefault(require("./SubtitleVariant.less"));
var hasValidLabel = function (label) { return label && label.length > 0 && !label.startsWith('http'); };
var ASS_BADGE = 'ASS';
var SubtitleVariant = function (_a) {
    var _b;
    var track = _a.track, selected = _a.selected, onSelect = _a.onSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var toast = (0, common_1.useToast)();
    var buttonRef = (0, react_1.useRef)(null);
    var triggers = (0, react_1.useMemo)(function () { return [buttonRef]; }, []);
    var downloadUrl = track.fallbackUrl || track.url;
    var variantLabel = hasValidLabel(track.label) ? track.label : common_1.languages.label(track.lang);
    var downloadFileName = hasValidLabel(track.label) ? track.label : "subtitle-".concat(track.lang || 'unknown');
    var canCopyUrl = typeof downloadUrl === 'string' && !downloadUrl.startsWith('blob:');
    var hoverTitle = hasValidLabel(track.label)
        ? track.label
        : ((_b = downloadUrl === null || downloadUrl === void 0 ? void 0 : downloadUrl.split('/').pop()) === null || _b === void 0 ? void 0 : _b.split('?')[0]) || variantLabel;
    var onSelectClick = (0, react_1.useCallback)(function () {
        onSelect(track);
    }, [onSelect, track]);
    var copyToClipboard = (0, react_1.useCallback)(function (value, successKey, errorKey) {
        navigator.clipboard.writeText(value)
            .then(function () { return toast.show({ type: 'success', title: t(successKey), timeout: 4000 }); })
            .catch(function () { return toast.show({ type: 'error', title: t(errorKey), timeout: 4000 }); });
    }, [toast, t]);
    var onCopyUrlClick = (0, react_1.useCallback)(function () {
        if (downloadUrl) {
            copyToClipboard(downloadUrl, 'PLAYER_COPY_SUBTITLE_URL_SUCCESS', 'PLAYER_COPY_SUBTITLE_URL_ERROR');
        }
    }, [downloadUrl, copyToClipboard]);
    var onCopyIdClick = (0, react_1.useCallback)(function () {
        if (track.addonSubtitleId) {
            copyToClipboard(track.addonSubtitleId, 'PLAYER_COPY_SUBTITLE_ID_SUCCESS', 'PLAYER_COPY_SUBTITLE_ID_ERROR');
        }
    }, [track.addonSubtitleId, copyToClipboard]);
    return (react_1.default.createElement(components_1.Button, { ref: buttonRef, title: hoverTitle, onClick: onSelectClick, className: (0, classnames_1.default)(SubtitleVariant_less_1.default['variant-option'], { 'selected': selected }) },
        react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['info'] },
            react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['variant-title'] },
                react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['variant-label'] }, variantLabel),
                track.ass ? react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['ass-badge'] }, ASS_BADGE) : null),
            react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['variant-origin'] }, t(track.origin))),
        selected ? react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['icon'] }) : null,
        !track.embedded &&
            react_1.default.createElement(components_1.ContextMenu, { on: triggers, autoClose: true, lock: 'bottom' },
                downloadUrl ?
                    react_1.default.createElement(components_1.Button, { className: SubtitleVariant_less_1.default['context-menu-option'], title: t('CTX_DOWNLOAD_SUBTITLE'), href: downloadUrl, target: '_blank', download: downloadFileName },
                        react_1.default.createElement(react_2.default, { className: SubtitleVariant_less_1.default['menu-icon'], name: 'download' }),
                        react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['context-menu-option-label'] }, t('CTX_DOWNLOAD_SUBTITLE')))
                    :
                        null,
                canCopyUrl ?
                    react_1.default.createElement(components_1.Button, { className: SubtitleVariant_less_1.default['context-menu-option'], title: t('CTX_COPY_SUBTITLE_URL'), onClick: onCopyUrlClick },
                        react_1.default.createElement(react_2.default, { className: SubtitleVariant_less_1.default['menu-icon'], name: 'link' }),
                        react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['context-menu-option-label'] }, t('CTX_COPY_SUBTITLE_URL')))
                    :
                        null,
                track.addonSubtitleId ?
                    react_1.default.createElement(components_1.Button, { className: SubtitleVariant_less_1.default['context-menu-option'], title: t('CTX_COPY_SUBTITLE_ID'), onClick: onCopyIdClick },
                        react_1.default.createElement(react_2.default, { className: SubtitleVariant_less_1.default['menu-icon'], name: 'share' }),
                        react_1.default.createElement("div", { className: SubtitleVariant_less_1.default['context-menu-option-label'] }, t('CTX_COPY_SUBTITLE_ID')))
                    :
                        null)));
};
exports.default = SubtitleVariant;
